<div #pageHeader id="pageHeader" class="pageHeader w3-margin">
  <h2>{{ pageheader.pageTitle | translate: session.transparams | customTitleCase }}</h2>
  <div *ngIf="session.transparams.customer_shortname == 'Inholland' && ( pageheader.pageTitle == 'pagetitle.login' || pageheader.pageTitle == 'pagetitle.surfconext')">
    <p>{{ 'login.line1' | translate: session.transparams }}</p>
    <p>{{ 'login.line2' | translate: session.transparams }}</p>
  </div>
  <omnipas-message></omnipas-message>
</div>
